import { render } from "./Autosuggest.vue?vue&type=template&id=7920862e"
import script from "./Autosuggest.vue?vue&type=script&lang=js"
export * from "./Autosuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/Autosuggest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7920862e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7920862e', __exports__)) {
    api.reload('7920862e', __exports__)
  }
  
  module.hot.accept("./Autosuggest.vue?vue&type=template&id=7920862e", () => {
    api.rerender('7920862e', render)
  })

}


export default __exports__